import api from '../utils/api';
import { LOGIN, USER_LOADED, LOGOUT, AUTH_ERROR, AUTH } from './types';
import { setAlert } from './alertAction';
import setAuthToken from '../utils/setAuthToken';

// Load User
export const loadUser = () => async (dispatch) => {
  try {
    const res = await api.get('/auth/me');
    dispatch({
      type: USER_LOADED,
      payload: res.data.data,
    });
  } catch (err) {
    console.log("test load user error", err);
    const errors = err.response.data.errors;
    if (errors)
      if (errors[0].msg === 'Session Expired') {
        dispatch({ type: LOGOUT });
      }
    dispatch({
      type: AUTH_ERROR,
    });
  }
};

export const login = (token) => async (dispatch) => {
  try {
    dispatch({ type: LOGIN, payload: { token } });
    dispatch(loadUser());
  } catch (err) {
    const errors = err.response.data.errors;

    // if we caught any errors we iterate through them and dispatch the setAlert action to add alerts
    if (errors) {
      if (errors[0].msg === 'Session Expired') {
        dispatch({ type: LOGOUT });
      } else
        errors.forEach((error) => dispatch(setAlert(error.message, 'danger')));
    }

    dispatch({
      type: AUTH_ERROR,
    });
  }
};

export const isAuth = () => async (dispatch) => {
  try {
    const res = await api.get('/auth/check');
    console.log(res.data.data);
    dispatch({ type: AUTH, payload: res.data.data });
    console.log(1);
    if (res.data.data) {
      console.log(1);
      setAuthToken(localStorage.token);
      dispatch(loadUser());
    }
  } catch (err) {
    const errors = err.response.data.errors;
    if (errors[0].msg === 'Session Expired') {
      dispatch({ type: LOGOUT });
    }
    dispatch({
      type: AUTH_ERROR,
    });
  }
};

// Logout
export const logout = () => async (dispatch) => {
  try {
   const response = await api.get(`/auth/logout`);
    localStorage.removeItem('token');
    sessionStorage.clear();
    dispatch({ type: LOGOUT });

    return response.data.logoutUri;
    
  } catch (error) {
    const errors = error.response.data.errors;
    if (errors)
      if (errors[0].msg === 'Session Expired') {
        dispatch({ type: LOGOUT });
      }
  }
};
